<div style="margin: 20px; min-height: 700px; min-width: 1200px">
  <div class="ui-g ui-fluid">
    <div class="ui-g-6">
      <label>Nazwa</label>
      <input pInputText maxlength="50" name="name" [(ngModel)]="validationConfiguration.name" />
      <label>Ważność konfiguracji</label>
      <div class="ui-g ui-fluid">
        <div class="ui-g-6">
          <input pInputText name="intervalValue" [(ngModel)]="validationConfiguration.intervalValue">
        </div>
        <div class="ui-g-6">
          <p-dropdown name="intervalUnit" placeholder="Wybierz jedn." [(ngModel)]="validationConfiguration.intervalUnit" [options]="intervalUnits"></p-dropdown>
        </div>
      </div>
    </div>

    <div class="ui-g-6">
      <label>Opis</label>
      <textarea pInputTextarea maxlength="255" name="description" [(ngModel)]="validationConfiguration.description" autoResize="autoResize" [rows]="4"></textarea>
    </div>

    <div class="ui-g-12">
      <p-button class="button" *ngIf="!validationConfiguration.items || validationConfiguration.items.length == 0" [routerLink]="'/validators/' + validationConfiguration.idValidationProvider + '/configs'" label="Zamknij"></p-button>
      <p-button class="button" name="add" (click)="addItem()" title="Dodaj walidację" label="Dodaj walidację"></p-button>
    </div>

    <div class="ui-g-12" *ngIf="validationConfiguration.items && validationConfiguration.items.length > 0">
      <p-table [value]="validationConfiguration.items">
        <ng-template pTemplate="header">
          <tr>
            <th>Kolejnosć</th>
            <th>Typ walidacji</th>
            <th>Wartość</th>
            <th>Akcja</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
          <tr>
            <td>
              <input pInputText name="order" [(ngModel)]="item.order" />
            </td>
            <td>
              <p-dropdown [options]="validationTypes" [(ngModel)]="item.validationType"></p-dropdown>
            </td>
            <td>
              <p-dropdown *ngIf="item.validationType && item.validationType == 4" [options]="tariffs" [(ngModel)]="item.validationValue"></p-dropdown>
              <div>
                <p-inputNumber *ngIf="item.validationType && (item.validationType == 1 || item.validationType == 5)" [(ngModel)]="item.validationValue" [showButtons]="true" mode="currency" currency="PLN" locale="pl">
                </p-inputNumber>
                <p-inputNumber *ngIf="item.validationType && item.validationType == 2" [(ngModel)]="item.validationValue" mode="decimal" [showButtons]="true" [min]="1" max="100" suffix="%">
                </p-inputNumber>
                <p-inputNumber *ngIf="item.validationType && item.validationType == 6" [(ngModel)]="item.validationValue" mode="decimal" [showButtons]="true" [min]="0" siffix="%">
                </p-inputNumber>
                <p-inputNumber *ngIf="!item.validationType || item.validationType == 0" [(ngModel)]="item.validationValue" mode="decimal" [showButtons]="true" [min]="1" suffix="min">
                </p-inputNumber>
                <div *ngIf="item.validationType && item.validationType == 7" class="ui-g ui-fluid">
                  <div class="ui-g-6">
                    <p-inputNumber [(ngModel)]="item.validationValue" mode="decimal" [min]="1">
                    </p-inputNumber>
                  </div>
                  <div class="ui-g-6">
                    <p-dropdown [options]="intervalUnits" placeholder="Wybierz jedn." [(ngModel)]="item.validationValueIntervalUnit"></p-dropdown>
                  </div>
                </div>
              </div>
            </td>
            <td>
              <fa-stack size="1x" style="cursor: pointer; float: right;" (click)="delItem(rowIndex)" title="Usuń">
                <fa-icon icon="square" stackItemSize="2x"></fa-icon>
                <fa-icon icon="times" [inverse]="true" stackItemSize="1x"></fa-icon>
              </fa-stack>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div>
        <p-button class="button" [routerLink]="'/validators/' + validationConfiguration.idValidationProvider + '/configs'" label="Zamknij"></p-button>
        <p-button class="button" (click)="save()" label="Zapisz"></p-button>
      </div>
    </div>
  </div>
</div>
